import { render, staticRenderFns } from "./SecurityInfoCard.vue?vue&type=template&id=4037e3ce&scoped=true"
import script from "./SecurityInfoCard.vue?vue&type=script&lang=js"
export * from "./SecurityInfoCard.vue?vue&type=script&lang=js"
import style0 from "./SecurityInfoCard.vue?vue&type=style&index=0&id=4037e3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4037e3ce",
  null
  
)

export default component.exports